export default __webpack_public_path__ + "static/media/DancingScript-Regular.0e407c56.ttf";